import React from 'react';

import Typography from '@ts-core/components/Typography';

interface RichHtmlTextProps {
  content?: string;
  loading?: boolean;
}

const RichHtmlText = ({ content, loading = false }: RichHtmlTextProps) => {
  if (loading) {
    return (
      <Typography loading={loading} skeletonProps={{ lines: 4 }}>
        Loading
      </Typography>
    );
  }

  if (!content) {
    return <span />;
  }

  return (
    <div
      className="ck-content"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default RichHtmlText;
